import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Typeahead } from './TypeaheadBase.styles';
import { formatTypeaheadSuggestions } from './utils';

const TypeaheadBase = (props) => {

    const {
        disabled,
        suggestions,
        placeholder,
        value,
        onItemClick,
        onChange,
        onFocus,
        onClearInput,
        cancelButtonRef,
        inputRef,
        className,
        baseImageProps,
        shouldShowLabels,
        inputType,
        shouldShowCancelButton,
        shouldClearValueOnSelect,
    } = props;

    const data = useMemo(() => formatTypeaheadSuggestions({
        suggestions,
        shouldShowLabels,
        baseImageProps,
    }), [
        suggestions,
        shouldShowLabels,
        baseImageProps,
    ]);

    return (
        <Typeahead
            additionalProps={{
                disabled,
            }}
            placeHolder={disabled ? '' : placeholder}
            inputType={inputType}
            cancelButton={shouldShowCancelButton}
            onItemClick={onItemClick}
            handlers={{
                onChange,
                onFocus,
            }}
            data={data}
            resetHandlers={{
                onClick: onClearInput,
            }}
            value={value}
            cancelButtonRef={cancelButtonRef}
            refElement={inputRef}
            className={className}
            shouldClearValueOnSelect={shouldClearValueOnSelect}
        />
    );

};

TypeaheadBase.propTypes = {
    disabled: PropTypes.bool,
    suggestions: PropTypes.array,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onItemClick: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onClearInput: PropTypes.func,
    cancelButtonRef: PropTypes.object,
    inputRef: PropTypes.object,
    className: PropTypes.string,
    baseImageProps: PropTypes.object,
    shouldShowLabels: PropTypes.bool,
    inputType: PropTypes.string,
    shouldShowCancelButton: PropTypes.bool,
    shouldClearValueOnSelect: PropTypes.bool,
};

TypeaheadBase.defaultProps = {
    disabled: undefined,
    suggestions: [],
    placeholder: '',
    value: '',
    onItemClick: () => {},
    onChange: () => {},
    onFocus: () => {},
    onClearInput: () => {},
    cancelButtonRef: null,
    inputRef: null,
    className: '',
    baseImageProps: {},
    shouldShowLabels: false,
    inputType: 'search',
    shouldShowCancelButton: true,
    shouldClearValueOnSelect: true,
};

export default TypeaheadBase;
